import { render, staticRenderFns } from "./UserImportDialog.vue?vue&type=template&id=a6160d56&"
import script from "./UserImportDialog.vue?vue&type=script&lang=ts&"
export * from "./UserImportDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports